import { useTranslation } from 'react-i18next'

import { Field } from '../../../../../../Field'
import { Status, STATUS_SIZE_20 } from '../../../../../../Status'
import { APPLICANT_CREDIT_CHECK_PROVIDER_TEXT_COLOR } from '../../ApplicantCreditCheckBlock.constants'
import { QA_NAME_APPLICANT_CREDIT_CHECK_VERDICT_EXTRACTED } from '../ApplicantCreditCheckVerdictModal.constants'

import * as styles from './ApplicantCreditCheckVerdictModalField.module.css'

function ApplicantCreditCheckVerdictModalField({
  children,
  isExtracted,
  ...fieldProps
}) {
  const { t } = useTranslation()

  return (
    <Field {...fieldProps} fieldInputClassName={styles.extractedField}>
      {children}
      {isExtracted ? (
        <Status
          className={styles.extractedChip}
          height={STATUS_SIZE_20}
          qaName={QA_NAME_APPLICANT_CREDIT_CHECK_VERDICT_EXTRACTED}
          text={t('RentalPortal.ApplicantCreditCheckVerdictExtractedKey')}
          textColor={APPLICANT_CREDIT_CHECK_PROVIDER_TEXT_COLOR}
          tooltip={t(
            'RentalPortal.ApplicantCreditCheckVerdictExtractedHintKey'
          )}
        />
      ) : null}
    </Field>
  )
}

export default ApplicantCreditCheckVerdictModalField
